import { useContext } from 'react'
import { Col, Form } from 'react-bootstrap'
import { toast } from 'react-toastify'
import hocFrom from '../../../components/forms/HocFrom'
import InputFarsi from '../../../components/inputs/InputFarsi'
import InputFile from '../../../components/inputs/InputFile'
import Switchrs from '../../../components/inputs/Switchrs'
import Loader from '../../../components/layout/Loader'
import DashboardContext from '../../../Context'

const FormWorkerDocument = ({ handelUpdataFrom,
    handelSend, loding, handelLoadingform, LoadingForm,
    dataUpdate, handelsetdataForm, formdata, urlWebsilte }) => {

    const { idview, Workername } = useContext(DashboardContext)


    //console.log(formdata);

    const handelValue = (name, value) => {
        switch (name) {

            case 'title':
                handelsetdataForm({ ...formdata, title: value, workerId: JSON.parse(sessionStorage.getItem('workerId')) ? JSON.parse(sessionStorage.getItem('workerId')) : idview ? idview : dataUpdate.workerId })
                break;
            case 'description':
                handelsetdataForm({ ...formdata, description: value })
                break;
            case 'file':
                handelsetdataForm({ ...formdata, file: value })
                break;
            case 'isActiveFormWorkerDocument':
                handelsetdataForm({ ...formdata, isActive: value })
                break;
            default:
                break;
        }
    }


    const handelSubmit = event => {
        event.preventDefault()
        handelLoadingform(true)

        if (!formdata.title) {
            toast.error("لطفا  عنوان سند وارد  کنید", {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            handelLoadingform(false)
        }
        else if (!formdata.description) {
            toast.error("لطفا  توضیحات وارد  کنید", {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            handelLoadingform(false)
        }

        else {
            dataUpdate.title ? handelUpdataFrom() : handelSend()

        }
    }



    return (
        <>
            {
                loding ?
                    <Loader />
                    :
                    <Form>
                        <Form.Row>
                            <Col className='d-flex align-items-center justify-content-center' >
                                <p>نام و نا م خانوادگی : </p>{" "}<p>{Workername ? Workername : formdata.workerName}</p>
                            </Col>
                            <Col>
                                <InputFarsi label='عنوان سند' name='title' handelValue={handelValue} defaultValue={dataUpdate.title} />
                            </Col>
                        </Form.Row>
                        <Form.Row>
                            <Col>
                                <div className="form-group">
                                    <label for="descriptionTextarea"> توضیحات </label>
                                    <textarea className="form-control" id="descriptionTextarea"
                                        rows="6" defaultValue={dataUpdate ? dataUpdate.description : ''}
                                        onChange={(e) => handelValue('description', e.target.value)} ></textarea>
                                </div>
                            </Col>
                        </Form.Row>
                        <Form.Row>
                            <Col>
                                <InputFile label='فایل' name='file' handelValue={handelValue} defaultValue={dataUpdate.file} />
                            </Col>
                            <Switchrs
                                label='آیا فعال باشد؟' name='isActiveFormWorkerDocument'
                                handelValue={handelValue} checke={formdata.isActive}
                            />
                        </Form.Row>
                        <Form.Row>
                            <Col>
                                <button type='submit'
                                    className='btn btn-success'
                                    onClick={handelSubmit}
                                    disabled={LoadingForm}
                                >
                                    {LoadingForm ? <i className="fa fa-spinner fa-pulse fa-fw"></i> :
                                        dataUpdate.title ? "ثبت ویرایش" : "ثبت"}
                                </button>
                            </Col>
                        </Form.Row>

                    </Form>
            }
        </>
    )
}

export default hocFrom(FormWorkerDocument)